/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AllowedConfigs = 'AMI_NAME_IRR' | 'AMI_NAME_CDVX' | 'LAMBDA_ZIPFILE_NAME' | 'GCP_DEPLOYMENT_VERSION' | 'GCP_IRR_IMAGE_NAME' | 'GCP_CDVX_IMAGE_NAME' | 'GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME' | 'VMCFS_AMI_NAME_IRR' | 'VMCFS_AMI_NAME_CDVX' | 'VMCFS_LAMBDA_ZIPFILE_NAME' | 'ORG_SCAN_THREAD_DELAY_MS' | 'DEPLOYMENT_COMPLETION_DELAY_MS' | 'IRR_VERSION_WITH_PKCE_SUPPORT' | 'INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS' | 'AGENT_PAIRING_CODES_LENGTH' | 'AGENT_PAIRING_CODES_VALIDITY_SECONDS' | 'AGENT_PAIRING_POLL_INTERVAL_SECONDS' | 'DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION' | 'DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION' | 'S3_EXPIRY_DURATION_DAYS' | 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED' | 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED' | 'ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS' | 'TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE' | 'VCF_CSP_BACKEND_URL' | 'VCF_CSP_CONSOLE_URL' | 'VMC_CSP_BACKEND_URL' | 'VMC_CSP_CONSOLE_URL' | 'VMC_BACKEND_URL' | 'VMC_CONSOLE_URL' | 'VLR_CONSOLE_SETTINGS_URL_SUFFIX' | 'VMCFS_CONSOLE_SETTINGS_URL_SUFFIX' | 'ASUP_BACKEND_URL' | 'VLR_CONSOLE_URL' | 'VMCFS_CONSOLE_URL' | 'SP_BACKEND_URL' | 'VCF_SERVICE_ROLES_TO_ADD_VMC_USERS' | 'MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS' | 'MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS' | 'MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS' | 'BYO_RESOURCE_SUPPORTED_PROVIDERS' | 'COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT' | 'CHECK_FE_ON_UPGRADE_TIMEOUT' | 'BILLING_PROCESSING_DELAY_DAYS' | 'BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS' | 'NOTIFICATION_BATCH_SIZE' | 'ORG_TYPE_DEFAULT' | 'QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS' | 'ENABLE_FEATURE_FLAG_AUDIT' | 'ENABLE_FEATURE_FLAG_NOTIFICATION' | 'ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT' | 'ENABLE_FEATURE_FLAG_INPUT_VALIDATION' | 'ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY' | 'ENABLE_FEATURE_FLAG_SEED_OAUTH_APP' | 'ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS' | 'ENABLE_FEATURE_FLAG_ORG_MIGRATION' | 'ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER' | 'ENABLE_FEATURE_FLAG_TASK_CANCELLATION' | 'ENABLE_FEATURE_FLAG_VCDR_NEW_FQDN_SCHEME' | 'ENABLE_FEATURE_FLAG_USE_NATIVE_APPS' | 'ENABLE_FEATURE_FLAG_CB_ADDRESS_VALIDATION' | 'ENABLE_FEATURE_FLAG_DELETE_ALL_OLD_SECRETS_FROM_ADMIN_ACCOUNT' | 'ENABLE_FEATURE_FLAG_CACHING' | 'ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE' | 'ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS' | 'ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API' | 'ENABLE_FEATURE_FLAG_IRR_POLLER' | 'ENABLE_FEATURE_FLAG_BILLING_PIPELINE_SCHEDULER' | 'ENABLE_FEATURE_FLAG_BILLING_RAW_SUBSCRIPTION_SCHEDULER' | 'ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE' | 'ENABLE_FEATURE_FLAG_RAW_SUBSCRIPTION_FULL_SYNC' | 'ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA' | 'ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER' | 'ENABLE_FEATURE_FLAG_SDDC_SCANNER' | 'ENABLE_FEATURE_FLAG_GCP' | 'ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION' | 'ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT' | 'ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE' | 'ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION' | 'ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY' | 'ENABLE_FEATURE_FLAG_VMC_HOST_USAGE';

export const AllowedConfigs = {

    AMI_NAME_IRR: 'AMI_NAME_IRR' as AllowedConfigs,

    AMI_NAME_CDVX: 'AMI_NAME_CDVX' as AllowedConfigs,

    LAMBDA_ZIPFILE_NAME: 'LAMBDA_ZIPFILE_NAME' as AllowedConfigs,

    GCP_DEPLOYMENT_VERSION: 'GCP_DEPLOYMENT_VERSION' as AllowedConfigs,

    GCP_IRR_IMAGE_NAME: 'GCP_IRR_IMAGE_NAME' as AllowedConfigs,

    GCP_CDVX_IMAGE_NAME: 'GCP_CDVX_IMAGE_NAME' as AllowedConfigs,

    GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME: 'GCP_CLOUDRUN_JOB_CONTAINER_IMAGE_NAME' as AllowedConfigs,

    VMCFS_AMI_NAME_IRR: 'VMCFS_AMI_NAME_IRR' as AllowedConfigs,

    VMCFS_AMI_NAME_CDVX: 'VMCFS_AMI_NAME_CDVX' as AllowedConfigs,

    VMCFS_LAMBDA_ZIPFILE_NAME: 'VMCFS_LAMBDA_ZIPFILE_NAME' as AllowedConfigs,

    ORG_SCAN_THREAD_DELAY_MS: 'ORG_SCAN_THREAD_DELAY_MS' as AllowedConfigs,

    DEPLOYMENT_COMPLETION_DELAY_MS: 'DEPLOYMENT_COMPLETION_DELAY_MS' as AllowedConfigs,

    IRR_VERSION_WITH_PKCE_SUPPORT: 'IRR_VERSION_WITH_PKCE_SUPPORT' as AllowedConfigs,

    INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS: 'INVENTORY_QUEUE_MESSAGE_RETENTION_DAYS' as AllowedConfigs,

    AGENT_PAIRING_CODES_LENGTH: 'AGENT_PAIRING_CODES_LENGTH' as AllowedConfigs,

    AGENT_PAIRING_CODES_VALIDITY_SECONDS: 'AGENT_PAIRING_CODES_VALIDITY_SECONDS' as AllowedConfigs,

    AGENT_PAIRING_POLL_INTERVAL_SECONDS: 'AGENT_PAIRING_POLL_INTERVAL_SECONDS' as AllowedConfigs,

    DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION: 'DPX_SRM_MINIMUM_SUPPORTED_AGENT_VERSION' as AllowedConfigs,

    DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION: 'DPX_SRM_MINIMUM_SUPPORTED_SRM_VERSION' as AllowedConfigs,

    S3_EXPIRY_DURATION_DAYS: 'S3_EXPIRY_DURATION_DAYS' as AllowedConfigs,

    CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED: 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_DEGRADED' as AllowedConfigs,

    CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED: 'CLOUD_SUBSCRIPTION_DAYS_TO_CLOUD_SUB_SUSPENDED' as AllowedConfigs,

    ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS: 'ACTIVATE_VLR_AGENT_JOB_EXPIRY_IN_HOURS' as AllowedConfigs,

    TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE: 'TASKS_EVENTS_DB_FETCH_MAX_PAGE_SIZE' as AllowedConfigs,

    VCF_CSP_BACKEND_URL: 'VCF_CSP_BACKEND_URL' as AllowedConfigs,

    VCF_CSP_CONSOLE_URL: 'VCF_CSP_CONSOLE_URL' as AllowedConfigs,

    VMC_CSP_BACKEND_URL: 'VMC_CSP_BACKEND_URL' as AllowedConfigs,

    VMC_CSP_CONSOLE_URL: 'VMC_CSP_CONSOLE_URL' as AllowedConfigs,

    VMC_BACKEND_URL: 'VMC_BACKEND_URL' as AllowedConfigs,

    VMC_CONSOLE_URL: 'VMC_CONSOLE_URL' as AllowedConfigs,

    VLR_CONSOLE_SETTINGS_URL_SUFFIX: 'VLR_CONSOLE_SETTINGS_URL_SUFFIX' as AllowedConfigs,

    VMCFS_CONSOLE_SETTINGS_URL_SUFFIX: 'VMCFS_CONSOLE_SETTINGS_URL_SUFFIX' as AllowedConfigs,

    ASUP_BACKEND_URL: 'ASUP_BACKEND_URL' as AllowedConfigs,

    VLR_CONSOLE_URL: 'VLR_CONSOLE_URL' as AllowedConfigs,

    VMCFS_CONSOLE_URL: 'VMCFS_CONSOLE_URL' as AllowedConfigs,

    SP_BACKEND_URL: 'SP_BACKEND_URL' as AllowedConfigs,

    VCF_SERVICE_ROLES_TO_ADD_VMC_USERS: 'VCF_SERVICE_ROLES_TO_ADD_VMC_USERS' as AllowedConfigs,

    MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_STATIC_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_DYNAMIC_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS: 'MANAGED_SHARABLE_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    BYO_RESOURCE_SUPPORTED_PROVIDERS: 'BYO_RESOURCE_SUPPORTED_PROVIDERS' as AllowedConfigs,

    COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT: 'COMPONENT_CATEGORY_HEALTH_DETAILS_MAX_COUNT' as AllowedConfigs,

    CHECK_FE_ON_UPGRADE_TIMEOUT: 'CHECK_FE_ON_UPGRADE_TIMEOUT' as AllowedConfigs,

    BILLING_PROCESSING_DELAY_DAYS: 'BILLING_PROCESSING_DELAY_DAYS' as AllowedConfigs,

    BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS: 'BILLING_SUBSCRIPTION_EXPIRING_NOTIFICATION_TRIGGER_DAYS' as AllowedConfigs,

    NOTIFICATION_BATCH_SIZE: 'NOTIFICATION_BATCH_SIZE' as AllowedConfigs,

    ORG_TYPE_DEFAULT: 'ORG_TYPE_DEFAULT' as AllowedConfigs,

    QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS: 'QUARTZ_SCHEDULER_INITIAL_DELAY_SECONDS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_AUDIT: 'ENABLE_FEATURE_FLAG_AUDIT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_NOTIFICATION: 'ENABLE_FEATURE_FLAG_NOTIFICATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT: 'ENABLE_FEATURE_FLAG_NOTIFICATION_STATUS_CHECK_LIMIT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_INPUT_VALIDATION: 'ENABLE_FEATURE_FLAG_INPUT_VALIDATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY: 'ENABLE_FEATURE_FLAG_RANSOMWARE_RECOVERY' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SEED_OAUTH_APP: 'ENABLE_FEATURE_FLAG_SEED_OAUTH_APP' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS: 'ENABLE_FEATURE_FLAG_ORG_SCAN_SCHEDULERS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ORG_MIGRATION: 'ENABLE_FEATURE_FLAG_ORG_MIGRATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER: 'ENABLE_FEATURE_FLAG_DYNAMIC_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_TASK_CANCELLATION: 'ENABLE_FEATURE_FLAG_TASK_CANCELLATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_VCDR_NEW_FQDN_SCHEME: 'ENABLE_FEATURE_FLAG_VCDR_NEW_FQDN_SCHEME' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_USE_NATIVE_APPS: 'ENABLE_FEATURE_FLAG_USE_NATIVE_APPS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CB_ADDRESS_VALIDATION: 'ENABLE_FEATURE_FLAG_CB_ADDRESS_VALIDATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_DELETE_ALL_OLD_SECRETS_FROM_ADMIN_ACCOUNT: 'ENABLE_FEATURE_FLAG_DELETE_ALL_OLD_SECRETS_FROM_ADMIN_ACCOUNT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_CACHING: 'ENABLE_FEATURE_FLAG_CACHING' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE: 'ENABLE_FEATURE_FLAG_FORWARD_STATS_TO_BILLING_ENGINE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS: 'ENABLE_FEATURE_FLAG_TRIM_COMPONENT_HEALTH_DETAILS' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API: 'ENABLE_FEATURE_FLAG_ENABLE_PRE_UPGRADE_CHECK_API' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_POLLER: 'ENABLE_FEATURE_FLAG_IRR_POLLER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_BILLING_PIPELINE_SCHEDULER: 'ENABLE_FEATURE_FLAG_BILLING_PIPELINE_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_BILLING_RAW_SUBSCRIPTION_SCHEDULER: 'ENABLE_FEATURE_FLAG_BILLING_RAW_SUBSCRIPTION_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE: 'ENABLE_FEATURE_FLAG_FAST_API_SUBSCRIPTION_SOURCE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_RAW_SUBSCRIPTION_FULL_SYNC: 'ENABLE_FEATURE_FLAG_RAW_SUBSCRIPTION_FULL_SYNC' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA: 'ENABLE_FEATURE_FLAG_PURGE_ORG_METADATA' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER: 'ENABLE_FEATURE_FLAG_IRR_QUOTA_PUSH_SCHEDULER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SDDC_SCANNER: 'ENABLE_FEATURE_FLAG_SDDC_SCANNER' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP: 'ENABLE_FEATURE_FLAG_GCP' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION: 'ENABLE_FEATURE_FLAG_GCP_SA_IMPERSONATION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT: 'ENABLE_FEATURE_FLAG_SDDC_MANAGEMENT' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE: 'ENABLE_FEATURE_FLAG_GCP_CUSTOM_DEVELOPER_ROLE' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION: 'ENABLE_FEATURE_FLAG_GCP_CLOUDRUN_JOB_DELETION' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY: 'ENABLE_FEATURE_FLAG_IRR_PROXY_API_RETRY' as AllowedConfigs,

    ENABLE_FEATURE_FLAG_VMC_HOST_USAGE: 'ENABLE_FEATURE_FLAG_VMC_HOST_USAGE' as AllowedConfigs
};

